import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {InfoDialogContainerComponent} from '../info-dialog-container/info-dialog-container.component';
import {MatConfirmDialogComponent} from '../mat-confirm-dialog/mat-confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog) {
  }

  openConfirmDialog(msg: any) {
    return this.dialog.open(MatConfirmDialogComponent, {
      minWidth: '500px',
      panelClass: 'confirm-dialog-container',
      disableClose: true,
      data: {
        message: msg
      }
    })
  }

  openInfoDialog(msg: any) {
    return this.dialog.open(InfoDialogContainerComponent, {
      minWidth: '500px',
      panelClass: 'confirm-dialog-container',
      disableClose: true,
      data: {
        message: msg
      }
    })
  }
}
